// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateDebitCardRequest
 */
export interface ICreateDebitCardRequest {
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    token_id: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    name_on_card: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    encrypted_card_number: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    encrypted_expiration_month: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    encrypted_expiration_year: string;
    /**
     * 
     * @type {Date}
     * @memberof ICreateDebitCardRequest
     */
    card_expiration_date: Date;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    card_last4: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    card_type: ICreateDebitCardRequestCardTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    address_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    street_address?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    locality?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    postal_code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateDebitCardRequest
     */
    country?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICreateDebitCardRequestCardTypeEnum {
    AMEX = 'AMEX',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD'
}


/**
 * Check if a given object implements the ICreateDebitCardRequest interface.
 */
export function instanceOfICreateDebitCardRequest(value: object): value is ICreateDebitCardRequest {
    if (!('token_id' in value) || value['token_id'] === undefined) return false;
    if (!('name_on_card' in value) || value['name_on_card'] === undefined) return false;
    if (!('encrypted_card_number' in value) || value['encrypted_card_number'] === undefined) return false;
    if (!('encrypted_expiration_month' in value) || value['encrypted_expiration_month'] === undefined) return false;
    if (!('encrypted_expiration_year' in value) || value['encrypted_expiration_year'] === undefined) return false;
    if (!('card_expiration_date' in value) || value['card_expiration_date'] === undefined) return false;
    if (!('card_last4' in value) || value['card_last4'] === undefined) return false;
    if (!('card_type' in value) || value['card_type'] === undefined) return false;
    return true;
}

export function ICreateDebitCardRequestFromJSON(json: any): ICreateDebitCardRequest {
    return ICreateDebitCardRequestFromJSONTyped(json, false);
}

export function ICreateDebitCardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateDebitCardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token_id': json['token_id'],
        'name_on_card': json['name_on_card'],
        'encrypted_card_number': json['encrypted_card_number'],
        'encrypted_expiration_month': json['encrypted_expiration_month'],
        'encrypted_expiration_year': json['encrypted_expiration_year'],
        'card_expiration_date': (new Date(json['card_expiration_date'])),
        'card_last4': json['card_last4'],
        'card_type': json['card_type'],
        'address_type': json['address_type'] == null ? undefined : json['address_type'],
        'street_address': json['street_address'] == null ? undefined : json['street_address'],
        'locality': json['locality'] == null ? undefined : json['locality'],
        'region': json['region'] == null ? undefined : json['region'],
        'postal_code': json['postal_code'] == null ? undefined : json['postal_code'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function ICreateDebitCardRequestToJSON(json: any): ICreateDebitCardRequest {
    return ICreateDebitCardRequestToJSONTyped(json, false);
}

export function ICreateDebitCardRequestToJSONTyped(value?: ICreateDebitCardRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token_id': value['token_id'],
        'name_on_card': value['name_on_card'],
        'encrypted_card_number': value['encrypted_card_number'],
        'encrypted_expiration_month': value['encrypted_expiration_month'],
        'encrypted_expiration_year': value['encrypted_expiration_year'],
        'card_expiration_date': ((value['card_expiration_date']).toISOString().substring(0,10)),
        'card_last4': value['card_last4'],
        'card_type': value['card_type'],
        'address_type': value['address_type'],
        'street_address': value['street_address'],
        'locality': value['locality'],
        'region': value['region'],
        'postal_code': value['postal_code'],
        'country': value['country'],
    };
}

